import { useCallback, useState } from 'react';
import { toast, useClient, useI18n } from '@ywwwtseng/react-kit';

export function useBlockedWhenServiceUpdated<T extends unknown[]>(
  callback: (...args: T) => Promise<unknown>
) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useI18n();
  const { query } = useClient();

  const mutate = useCallback(
    async (...args: T): Promise<unknown> => {
      try {
        setIsLoading(true);
        const res = await query('system_status');
        const { data } = res.data as { data: string | undefined };

        if (data === 'deploying') {
          toast.error(t('message.system_maintenance'));
          setIsLoading(false);
          return;
        }

        const result = await callback(...args);
        setIsLoading(false);
        return result;
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    },
    [callback, query]
  );

  return {
    mutate,
    isLoading,
  };
}
